import React from 'react';
import { motion } from 'framer-motion';

interface AuthLeftSectionProps {
  image: string;
  imageAlt: string;
  title: string;
  description: string;
  slideInLeft: any;
  fadeInUp: any;
  floatingAnimation: any;
}

const AuthLeftSection: React.FC<AuthLeftSectionProps> = ({
  image,
  imageAlt,
  title,
  description,
  slideInLeft,
  fadeInUp,
  floatingAnimation
}) => {
  return (
    <motion.div
      className="text-center col-md-6 my-auto"
      variants={slideInLeft}
      style={{ position: 'relative', zIndex: 1 }}
    >

      {/* Image with floating animation and decorative elements */}
      <motion.div
        style={{
          position: 'relative',
          display: 'inline-block',
          zIndex: 2
        }}
        variants={floatingAnimation}
        animate="animate"
      >
        <motion.img
          src={image}
          alt={imageAlt}
          className="login-image"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{
            duration: 1.2,
            ease: "easeOut",
            delay: 0.5
          }}
        />

        {/* Decorative floating elements near the image */}
        <motion.div
          style={{
            position: 'absolute',
            top: '-10px',
            right: '-10px',
            width: '20px',
            height: '20px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #D7A360, #f4d03f)',
            opacity: 0.8,
            zIndex: 3
          }}
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.7, 0.9, 0.7]
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            delay: 1
          }}
        />
        <motion.div
          style={{
            position: 'absolute',
            bottom: '20px',
            left: '-15px',
            width: '15px',
            height: '15px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #3957A0, #5c7cfa)',
            opacity: 0.7,
            zIndex: 3
          }}
          animate={{
            scale: [1, 1.3, 1],
            opacity: [0.6, 0.8, 0.6]
          }}
          transition={{
            duration: 2.5,
            repeat: Infinity,
            delay: 1.5
          }}
        />
      </motion.div>

      {/* Title and description with proper z-index */}
      <motion.h1
        className="mt-4"
        style={{ color: '#3957A0', fontSize: "30px", fontWeight: 700, position: 'relative', zIndex: 2 }}
        variants={fadeInUp}
        initial="hidden"
        animate="visible"
        transition={{ delay: 0.8 }}
        dangerouslySetInnerHTML={{ __html: title }}
      />

      <motion.p
        className="mt-4"
        style={{ color: '#677289', fontSize: "16px", fontWeight: 700, lineHeight: '1.6', position: 'relative', zIndex: 2 }}
        variants={fadeInUp}
        initial="hidden"
        animate="visible"
        transition={{ delay: 1 }}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </motion.div>
  );
};

export default AuthLeftSection;